import React from 'react';
import {useModal} from "../components/Modal";

const Catalogue = () => {
    const { handleShowModal, handleShowModalInfo } = useModal();

    return (
        <div id="content" className="catalogue-page">
            <div className="container">
                <div className="heading">
                    <h1>Katalog domů</h1>
                </div>
                <div className="info-box">
                    <h2>Možnost úpravy dispozic a sklonu střechy</h2>
                    <p>
                        Vnitřní uspořádání příček, dispozic, sklonu střechy nebo velikosti domů lze přizpůsobit vašemu požadavku.
                        Tyto požadavky mohou mít vliv na prezentovanou cenu. Pokud máte zájem o vlastní řešení, kontaktujte nás pro vytvoření cenové kalkulace.
                    </p>
                </div>
                <div className="catalogue">
                    <div className="catalogue-items">
                        <div className="item">
                            <div className="preview">
                                <img src="./images/catalogue/2kk/preview.jpg" alt="Dům 2+kk 50m" />
                            </div>
                            <div className="info">
                                <h3>Dům 2+kk 50 m<sup>2</sup></h3>
                                <div className="price">
                                    <span>2 495 000 Kč</span>
                                    <small>včetně DPH a&nbsp;základových patek</small>
                                </div>
                            </div>
                            <div className="params">
                                <ul>
                                    <li>dům na klíč s vnitřním vybavením</li>
                                    <li>střecha 10° - možnost vyššího sklonu</li>
                                    <li>podlahové vytápění</li>
                                    <li>tepelné čerpadlo</li>
                                    <li>rekuperace</li>
                                    <li>...</li>
                                </ul>
                                <a href="/dum-2kk" className="bttn detail">Zobrazit detail</a>
                            </div>
                        </div>
                        <div className="item">
                            <div className="preview">
                                <img src="./images/catalogue/3kk/preview.jpeg" alt="Dům 3+kk 80m" />
                            </div>
                            <div className="info">
                                <h3>Dům 3+kk 80 m<sup>2</sup></h3>
                                <div className="price">
                                    <span>3 695 000 Kč</span>
                                    <small>včetně DPH a&nbsp;základových patek</small>
                                </div>
                            </div>
                            <div className="params">
                                <ul>
                                    <li>dům na klíč s vnitřním vybavením</li>
                                    <li>střecha 10° - možnost vyššího sklonu</li>
                                    <li>podlahové vytápění</li>
                                    <li>tepelné čerpadlo</li>
                                    <li>fotovoltaika</li>
                                    <li>...</li>
                                </ul>
                                <a href="/dum-3kk" className="bttn detail">Zobrazit detail</a>
                            </div>
                        </div>
                        <div className="item">
                            <div className="preview">
                                <img src="./images/catalogue/4kk/preview.jpg" alt="Dům 4+kk 100m" />
                            </div>
                            <div className="info">
                                <h3>Dům 4+kk 110 m<sup>2</sup></h3>
                                <div className="price">
                                    <span>4 995 000 Kč</span>
                                    <small>včetně DPH a&nbsp;základových patek</small>
                                </div>
                            </div>
                            <div className="params">
                                <ul>
                                    <li>dům na klíč s vnitřním vybavením</li>
                                    <li>střecha 10° - možnost vyššího sklonu</li>
                                    <li>podlahové vytápění</li>
                                    <li>tepelné čerpadlo</li>
                                    <li>fotovoltaika</li>
                                    <li>...</li>
                                </ul>
                                <a href="/dum-4kk" className="bttn detail">Zobrazit detail</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="extra-info">
                    <div className="extra-text">
                        <h3>Co si zákazník libovolně vybírá</h3>
                        <ul>
                            <li>Dekor a materiál podlah (v ceně domu započtena sazba 329 Kč/m2)</li>
                            <li>Obklady do koupelny (v ceně domu započtena sazba 329 Kč/m2)</li>
                            <li>Dekor a styl interiérových dveří</li>
                            <li>Osvětlení, zásuvky a vypínače</li>
                            <li>Vanu nebo sprchový kout</li>
                            <li>Toaletu a umyvadlo</li>
                        </ul>
                    </div>
                    <div className="extra-banner">
                        <h2>
                            Máte zájem o individuální
                            vybavení domu?
                        </h2>
                        <p>
                            Neváhejte nás kontaktovat. Upravíme vám nabídku
                            dle vašich potřeb a požadavků.
                        </p>
                        <button onClick={handleShowModal} className="bttn center">Kontaktní formulář</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Catalogue;